import React from 'react';
import { Card, CardBody, Row, Col } from 'reactstrap';
import {
  PatientComment,
  RxComment,
  EncounterComment,
  ProviderComment,
  ProgramComment
} from 'components/Comments';

import PatientDetails from 'pages/Patient/components/PatientDetails';

const GlobalComments = ({ row, tenantID, coveredEntityID, data, orgId }) => {
  return (
    <>

      <div className='border-0 rounded-bottom-1 mt-3 table-card'>
        <div>
          <PatientDetails data={row} hasdetailsflag={true} orgId={orgId} coveredEntity={coveredEntityID} />
        </div>
      </div>

      <div className='border-0 rounded-bottom-1 mt-3 table-card'>
        <div>
          <PatientComment
            patientID={row?.patientID}
            coveredEntityID={coveredEntityID}
            tenantID={tenantID}
          />
        </div>
      </div>
      <div className='border-0 rounded-bottom-1 mt-3 table-card'>
        <div>
          <RxComment
            coveredEntityID={coveredEntityID}
            tenantID={tenantID}
            rxNumber={row?.rxNumber}
          />
        </div>
      </div>
      <Row>
        <Col md={6}>
          <div className='border-0 rounded-bottom-1 mt-3 table-card'>
            <div>
              <ProviderComment
                coveredEntityID={coveredEntityID}
                tenantID={tenantID}
                providerID={row?.providerID}
              />
            </div>
          </div>
        </Col>
        <Col md={6}>
          <div className='border-0 rounded-bottom-1 mt-3 table-card'>
            <div>
              <EncounterComment
                tenantID={tenantID}
                encounterID={row?.encounterID}
              />
            </div>
          </div>
        </Col>
      </Row>
      {/* <Card className='border-0 rounded-bottom-1 mt-3 table-card'>
        <CardBody>
          <ProgramComment
            commentID={row?.commentID}
            coveredEntityID={coveredEntityID}
            tenantID={tenantID}
          />
        </CardBody>
      </Card> */}
    </>
  );
};

export default GlobalComments;
